import React from 'react'
import image from '../../../assets/homepage_pro11.png';
const LowerBannerSix = () => {
    return (
        <>
            <div className="cate-bx6 common">
                <h3>
                    <span>With the new Experience &amp;</span> Masterclass
                </h3>
                <div className="cate-pro2">
                    <img className="img-fluid" src={image} alt="" />
                </div>
                <a href="#" className="btn-buy">
                    Read More
                </a>
            </div>

        </>
    )
}

export default LowerBannerSix